/* eslint no-debugger: 0, no-lonely-if: 0 */
import $ from 'jquery';
import Papa from 'papaparse';
import Highcharts from 'highcharts';
import buildChart from './charts';
import '../../legacy/searchlist';
import message from '../../../utils/message';
import locale from '../../../utils/locale';

// Load module after Highcharts is loaded
// require('highcharts/modules/data.src')(Highcharts);

/**
 * Highchartの基本設定
 */
Highcharts.setOptions({
  global: {
    useUTC: false,   // GMTではなくJSTを使う
  },
  lang: {
    months: message.months,
  },
  // exportingを出さない
  exporting: {
    enabled: false,
  },
  // クレジットを非表示
  credits: {
    enabled: false,
  },
});

// CSVボタンを押したとき
function ajax_chart_csv_download(act_nm, chart) {
  window.setSearchForm();
  $.ajax({
    url: act_nm,
    data: $(document.searchForm).serialize(),
  }).done((csv) => {
    const parsed_csv = Papa.parse(csv);
    chart(parsed_csv);
  });
}

// CSVボタンを押したとき
function ajax_chart_csv_downloadForAjaxPage(act_nm, form_name, chart) {
  $.ajax({
    url: act_nm,
    data: $(`form[name=${form_name}]`).serialize(),
  }).done((csv) => {
    const parsed_csv = Papa.parse(csv);
    chart(parsed_csv);
  });
}

function create_chart(csv_download_url) {
  let $csv_chart_area;
  if ($('#csv_chart_area').length === 0) {
    $csv_chart_area = $('<div id="csv_chart_area">Loading ...</div>');
    $('#info_list').before($csv_chart_area);
  } else {
    $csv_chart_area = $('#csv_chart_area');
  }
  ajax_chart_csv_download(csv_download_url, (data) => {
    buildChart($csv_chart_area, window.location.href, data);
  });
}
function create_chartForAjaxPage(csv_download_url, form_name) {
  let $csv_chart_area;
  if ($('#csv_chart_area').length === 0) {
    $csv_chart_area = $('<div id="csv_chart_area">Loading ...</div>');
    $('#info_list').before($csv_chart_area);
  } else {
    $csv_chart_area = $('#csv_chart_area');
  }
  ajax_chart_csv_downloadForAjaxPage(csv_download_url, form_name, (data) => {
    buildChart($csv_chart_area, window.location.href, data);
  });
}

function hasCsvDownloadButton() {
  if ($('.fa.fa-download').length === 0) {
    return false;
  }

  if ($('.fa.fa-download').closest('a').length === 0) {
    return false;
  }

  if ($('.fa.fa-download').closest('a').length > 1) {
    return false;
  }

  return true;
}
function isAjaxPage() {
  if (window.location.href.indexOf('/admin/aggregation/index') > -1) {
    return true;
  }
  return false;
}
function isCSVChartPage() {
  if (!isAjaxPage() && !hasCsvDownloadButton()) {
    return false;
  }

  if (window.location.href.indexOf('/admin/selectedtraining/sttest_set_list.cfm') > -1) {
    return true;
  }
  if (window.location.href.indexOf('/admin/selectedtraining/assign_index.cfm') > -1) {
    return true;
  }
  if (window.location.href.indexOf('/admin/selectedtraining/sttest_result.cfm') > -1) {
    return true;
  }
  if (window.location.href.indexOf('/admin/ClassPortfolio/external_exam.cfm') > -1) {
    return true;
  }
  if (window.location.href.indexOf('/admin/testcenter/result_users.cfm') > -1) {
    return true;
  }
  if (window.location.href.indexOf('/admin/selectedtraining/sttest_result_users.cfm') > -1) {
    return true;
  }
  if (window.location.href.indexOf('/admin/aggregation/index') > -1) {
    return true;
  }
  if (window.location.href.indexOf('/admin/aggregation/analysis') > -1) {
    return true;
  }
  return false;
}

function createChartButton() {
  const $csv_download_button = $('.fa.fa-download').closest('a');
  let csv_download_url = $csv_download_button.attr('href');
  csv_download_url = csv_download_url.replace(/javascript:csv_download\(["'](.*)["']\)/, '$1');
  const $createChartButton = $(`
<a href="#" class="btn btn-default btn-sm"><span class="icon"><i class="fa fa-bar-chart" aria-hidden="true"></i> Chart</span></a>
`);

  $createChartButton.click((e) => {
    e.preventDefault();
    create_chart(csv_download_url);
  });
  $csv_download_button.before($createChartButton);
  $createChartButton.after(' ');
}

function createChartButtonForAjaxPage() {
  const $csv_download_button = $('.fa.fa-download').closest('a');
  const form_name = $csv_download_button.attr('href').replace(/javascript:document\.(.*)\.submit\(\);/, '$1');
  const csv_download_url = $(`form[name=${form_name}]`).attr('action');
  const $createChartButton = $(`
<a href="#" class="btn btn-default btn-sm"><span class="icon"><i class="fa fa-bar-chart" aria-hidden="true"></i> Chart</span></a>
`);
  $createChartButton.click((e) => {
    e.preventDefault();
    create_chartForAjaxPage(csv_download_url, form_name);
  });
  $csv_download_button.before($createChartButton);
  $createChartButton.after(' ');
}

$(document).ready(() => {
  // 日本語の場合のみ、Chartボタン表示
  if (locale === 'ja') {
    if (isAjaxPage()) {
      $(document).ajaxComplete((event, jqXHR, ajaxOptions) => {
        console.log(ajaxOptions.url);
        if (ajaxOptions.url.indexOf('user.cfm') > -1) {
          createChartButtonForAjaxPage();
        }
      });
    } else {
      if (isCSVChartPage()) {
        createChartButton();
      }
    }
  }
});



// WEBPACK FOOTER //
// ./es6/admin-common-js/apps/csv_chart/index.js